import CloseController from '../../controllers/CloseController';
import { QuestItem } from './QuestItem';
import { DailyQuest } from './DailyQuest';
import QuestItemController from '../../controllers/quest/QuestItemController';
import QuestDailyController from '../../controllers/quest/QuestDailyController';
import { COMPONENTS } from '../../lib/constants';
import MainGridController from '../../controllers/grid/MainGridController';
import { QuestPageGrid } from './QuestPageGrid';
import QuestPageController from '../../controllers/quest/QuestPageController';

export const QuestPage = {
	name: COMPONENTS.QUEST_PAGE,
	child: true,
	zIndex: 2,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: CloseController,
			name: 'CloseController',
			config: {
				closeBtn: 'close',
				remove: true
			}
		},
		{
			Controller: QuestDailyController,
			name: 'QuestDailyController',
			config: {
				item: 'quest_daily',
				val: 'quest_daily'
			}
		},
		{
			Controller: QuestItemController,
			name: 'QuestItemController',
			config: {
				id: 1,
				item: 'quest_1',
				val: 'quest_1',
				name: 'General',
				texts: [
					'QUEST_ITEM_HEADER_1',
					'QUEST_ITEM_SUBTITLE_1',
					'QUEST_ITEM_DESC_1'
				],
				img: 'quest_major_1',
				color: '#71B2EE'
			}
		},
		{
			Controller: QuestItemController,
			name: 'QuestItemController',
			config: {
				item: 'quest_2',
				val: 'quest_2',
				id: 2,
				name: 'Scatter',
				texts: [
					'QUEST_ITEM_HEADER_2',
					'QUEST_ITEM_SUBTITLE_2',
					'QUEST_ITEM_DESC_2'
				],
				img: 'quest_scatter',
				color: '#B7EE71'
			}
		},
		{
			Controller: QuestItemController,
			name: 'QuestItemController',
			config: {
				item: 'quest_3',
				val: 'quest_3',
				id: 3,
				name: 'Star',
				texts: [
					'QUEST_ITEM_HEADER_3',
					'QUEST_ITEM_SUBTITLE_3',
					'QUEST_ITEM_DESC_3'
				],
				img: 'quest_star',
				color: '#B771EE'
			}
		},
		{
			Controller: QuestItemController,
			name: 'QuestItemController',
			config: {
				item: 'quest_4',
				val: 'quest_4',
				id: 4,
				name: 'Coin',
				texts: [
					'QUEST_ITEM_HEADER_4',
					'QUEST_ITEM_SUBTITLE_4',
					'QUEST_ITEM_DESC_4'
				],
				img: 'quest_coin',
				color: '#EE71AD'
			}
		},
		{
			Controller: MainGridController,
			name: 'QuestPageGrid',
			config: QuestPageGrid
		},
		{
			Controller: QuestPageController,
			name: 'QuestPageController',
			config: {
				holder: 'quest_view_holder_up',
				name: 'quest'
			}
		}
	],
	components: [
		{
			name: 'quest_view_holder_up',
			type: 'Sprite',
			components: [
				{
					name: 'bg',
					type: 'Sprite',
					img: 'reel_bg',
					position: { x: 0, y: 0 },
				},
				{
					name: "bg_border",
					type: "Sprite",
					img: "general_modal_frame",
					position: { x: 0, y: -5 },
				  },
				{
					name: 'quest_page_secondary_bg',
					type: 'Sprite',
					img: 'quest_page_secondary_bg',
					position: { x: 34, y: 272 }
				},
				{
					name: 'quest_featured_img',
					type: 'Sprite',
					img: 'quest_featured_img',
					position: { x: 16, y: 54 }
				},
				{
					name: 'header',
					type: 'CustomText',
					text: 'QUEST_DAILY_HEADER',
					position: { x: 380, y: 25 }
				},
				{
					name: 'close',
					type: 'Button',
					components: [
						{
							name: 'bg',
							type: 'MouseOverSprite',
							img: 'close_icon',
							imgHover: 'close_icon_hovered',
							position: { x: 1050, y: 15 }
						}
					]
				},
				{
					name: 'quest_daily',
					position: { x: 53, y: 0 },
					type: 'VisualComponent',
					component: DailyQuest
				},
				{
					name: 'quest_1',
					position: { x: 73, y: 315 },
					type: 'VisualComponent',
					component: QuestItem
				},
				{
					name: 'quest_2',
					position: { x: 72, y: 471 },
					type: 'VisualComponent',
					component: QuestItem
				},
				{
					name: 'quest_3',
					position: { x: 590, y: 471 },
					type: 'VisualComponent',
					component: QuestItem
				},
				{
					name: 'quest_4',
					position: { x: 590, y: 315 },
					type: 'VisualComponent',
					component: QuestItem
				}
			]
		}
	]
};
